import { EthereumRpcError, serializeError } from "eth-rpc-errors";
import { SerializedEthereumRpcError } from "eth-rpc-errors/dist/classes";

import { UnsupportedChainIdError } from "@web3-react/core";
import { UserRejectedRequestError as UserRejectedRequestErrorFrame } from "@web3-react/frame-connector";
import {
  NoEthereumProviderError,
  UserRejectedRequestError as UserRejectedRequestErrorInjected
} from "@web3-react/injected-connector";
import { UserRejectedRequestError as UserRejectedRequestErrorWalletConnect } from "@web3-react/walletconnect-connector";

interface RevertError {
	originalError: any
}

export function useErrorMessage() {
	const getErrorMessage = (error: unknown): string => {
		if (error) {
			const err = serializeError(error) as SerializedEthereumRpcError
			const BALANCE_EXCEEDED = err.message.indexOf(
				'Transaction amount exceeds maximum account balance.'
			)
			const INSUFFICIENT_PASSES = err.message.indexOf(
				'Account has no Mint Passes'
			)

			switch (err.code) {
				case 4001:
					return 'user rejected'
				case -32603:
					if (BALANCE_EXCEEDED != -1) {
						return 'purchase would exceed max account balance'
					}
					if (INSUFFICIENT_PASSES != -1) {
						return 'insufficient mint passes'
					}
					return 'insufficient funds'
			}
		}

		return 'internal failure'
	}

	return { getErrorMessage }
}
